<template>
  <DM ref="dm" />
  <div class="sql-editor">
  <!-- 标题栏 -->
  <div class="header">
    <span style="font-weight: bold;">{{ title }}</span>
  </div>

  <!-- 消息提示区 -->
  <div v-if="displayMessage" class="message">{{ displayMessage }}</div>

  <!-- 参数表格（核心修复：添加customCell阻止冒泡、编辑组件加唯一class） -->
  <a-table
    ref="tableRef"  
    :columns="columns"
    :data-source="tableData"
    bordered
    size="small"
    :pagination="false"
    :showHeader="false"
    :row-selection="null" 
    row-key="key"  
    style="position: relative; z-index: 10;" 
    :scroll="{ y: 'calc(32px * 10 + 2px)' }"     
  >
    <!-- 单元格渲染插槽：动态显示文本/编辑组件 -->
    <template #bodyCell="{ column, text, record, index }">
      <!-- 只处理“参数值”列的编辑 -->
      <template v-if="column.dataIndex === 'ParaValue'">
        <!-- 编辑状态：渲染对应编辑组件（加唯一class，方便聚焦） -->
        <template v-if="editingKey === `${record.key}-${column.dataIndex}`">
          <!-- 下拉框 -->
          <template v-if="getEditorType(record.ParaName) === '下拉框'">
            <a-select
              v-model:value="editableData[record.key][column.dataIndex]"
              style="margin: -5px 0; width: 100%; position: relative; z-index: 100;"
              class="table-edit-select" 
              @change="handleEditChange(record.key, column.dataIndex)"
              @blur="handleEditBlur(record.key, column.dataIndex, record)"
              @press-enter="handleEditBlur(record.key, column.dataIndex, record)"
            >
              <a-select-option v-for="item in getEditorItems(record.ParaName)" :key="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </template>
          <!-- 日期型 -->
          <template v-else-if="getEditorType(record.ParaName) === '日期型'">
            <a-date-picker
              v-model:value="editableData[record.key][column.dataIndex]"
              style="margin: -5px 0; width: 100%; position: relative; z-index: 100;"
              class="table-edit-date" 
              format="YYYY-MM-DD"
              @change="handleEditChange(record.key, column.dataIndex)"
              @blur="handleEditBlur(record.key, column.dataIndex, record)"
              @press-enter="handleEditBlur(record.key, column.dataIndex, record)"
            />
          </template>
          <!-- 单选框（是/否） -->
          <template v-else-if="getEditorType(record.ParaName) === '单选框'">
            <div style="display: flex; gap: 10px; align-items: center; margin: -5px 0; position: relative; z-index: 100;">
              <a-radio-button
                value="是"
                v-model:checked="editableData[record.key][column.dataIndex]"
                class="table-edit-radio" 
                @change="() => handleRadioChange(record.key, column.dataIndex, '是')"
              >
                是
              </a-radio-button>
              <a-radio-button
                value="否"
                v-model:checked="editableData[record.key][column.dataIndex]"
                class="table-edit-radio" 
                @change="() => handleRadioChange(record.key, column.dataIndex, '否')"
              >
                否
              </a-radio-button>
              <a-button
                size="small"
                type="text"
                @click="handleEditBlur(record.key, column.dataIndex, record)"
              >
                确定
              </a-button>
            </div>
          </template>
          <!-- 默认输入框 -->
          <template v-else>
            <a-input
              v-model:value="editableData[record.key][column.dataIndex]"
              style="margin: -5px 0; width: 100%; position: relative; z-index: 100;"
              class="table-edit-input" 
              @change="handleEditChange(record.key, column.dataIndex)"
              @blur="handleEditBlur(record.key, column.dataIndex, record)"
              @press-enter="handleEditBlur(record.key, column.dataIndex, record)"
              :placeholder="record.Remarks || '请输入内容'" 
              :title="record.Remarks || '请输入内容'" 
            />
          </template>
        </template>
        <!-- 普通状态：显示文本 -->
        <template v-else>
          <span
            :style="{
              backgroundColor: record.IsReadOnly === 1 ? '#ebebeb' : (record.IsNotNull !== 1 ? '#fafffa' : 'white'),
              lineHeight: '32px',
              cursor: record.IsReadOnly !== 1 ? 'pointer' : 'default',
              display: 'inline-block',
              width: '100%'
            }"
          >
            {{ text || '' }}
          </span>
        </template>
      </template>
      <!-- 其他列直接显示文本 -->
      <template v-else>
      <span 
        :style="{ 
          lineHeight: '32px', 
          display: 'inline-block', 
          width: '100%', 
          textAlign: 'center',
          // 动态设置颜色：如果是必填项则为红色，否则默认
          color: (
        (column.dataIndex === 'ParaName' && record.IsNotNull === 1)       ) ? 'red' : 'inherit'    }"
        :title="getTooltipText(column, record)" 
      >
        {{ column.dataIndex === 'IsNotNull' ? (text === 1 ? '必填' : '') : text }}
      </span>
</template>
    </template>
  </a-table>

  <!-- 操作按钮区（优化样式，提升层级） -->
  <div class="button-group" style="position: relative; z-index: 10; display: flex; align-items: center; gap: 8px;">
  <!-- 靠左的复选框 -->
  <a-checkbox 
    v-model:checked="chkNext" 
    :disabled="!chkNextEnabled" 
    style="margin: 0;"  
  >
    继续录入下一条
  </a-checkbox>    

  <!-- 用一个空div作为分隔，通过margin-left: auto推到右侧 -->
  <div style="margin-left: auto;"></div>

  <!-- 靠右的三个按钮 -->
  <!-- <a-button @click="handleClear" type="text" danger> -->
    <!-- 清除参数
  </a-button> -->

  <a-button @click="handleExit">
    {{ btnExitText }}
  </a-button>
  <a-button type="primary" @click="handleOk">
    {{ btnOkText }}
  </a-button>  
</div>
</div>
</template>
<script setup lang="ts">
// 从 vue 导入基础 API（不变）
import { ref, reactive, onMounted, nextTick,watch } from 'vue';
// 从 lodash 导入 cloneDeep
import { cloneDeep } from 'lodash'; // 新增这行
import { TableProps } from 'ant-design-vue';
import { Button, Table, Select, DatePicker, Checkbox, Input, Radio } from 'ant-design-vue';
import Message from 'ant-design-vue/es/message';
import dayjs, { Dayjs } from 'dayjs';
import DM from '/src/utils/dm.vue'
import f ,{sysInfo} from '/src/utils/f.ts'
import { h } from 'vue'

const dm = ref(null)
// 定义表格实例类型
const tableRef = ref<InstanceType<typeof Table> | null>(null);

// ================ 外部传入参数（不变） ================
const props = defineProps<{
  visible?: boolean; // 新增：控制组件显示/隐藏的 props
  itemCode: string;
  title?: string;
  parameters?: Record<string, any>;
}>();

// ================ 核心编辑状态（参考文章方案） ================
// 编辑标识：记录当前编辑的「行key-列dataIndex」（如 "0-ParaValue"）
const editingKey = ref('');
// 编辑数据缓存：临时存储编辑中的值（避免直接修改原数据）
const editableData: Record<string, any> = reactive({});

const tableData = ref<any[]>([]);
const editors = ref<any[]>([]);
const fSQLScript = ref('');
const fDBName = ref('');
const displayMessage = ref('');
const btnOkText = ref('执行');
const btnExitText = ref('关闭');
const chkNext = ref(false);
const chkNextEnabled = ref(true);
const bInit = ref(false);

const columns = ref<TableProps['columns']>([
  {
    title: '参数名',
    dataIndex: 'ParaName',
    key: 'ParaName',
    width: 150,
  },
  {
    title: '参数值',
    dataIndex: 'ParaValue',
    key: 'ParaValue',
    width: 260,
    customCell: (record: any) => {
      return {
        onClick: () => {
          // 只读行不触发编辑
          if (record.IsReadOnly !== 1) {
            startEdit(record);
          }
        },
      };
    },
  },
  // 第三列：是否必填
  // {
  //   title: '是否必填',
  //   dataIndex: 'IsNotNull',
  //   key: 'IsNotNull',
  //   width: 80,
  // },
]);


// 定义鼠标悬浮提示文字逻辑
const getTooltipText = (column: any, record: any) => {
  // 场景1：第一列（参数名）且是必填行
  if (column.dataIndex === 'ParaName' && record.IsNotNull === 1) {
    return '此参数为必填项，不能为空';
  }
  // 场景2：第一列（参数名）非必填行
  else if (column.dataIndex === 'ParaName') {
    return '点击参数值列可编辑';
  }
  // 场景3：必填标签列
  else if (column.dataIndex === 'IsNotNull' && record.IsNotNull === 1) {
    return '该参数为必填项';
  }
  // 其他场景（可选）
  else {
    return '点击可编辑参数值';
  }
};
// 新增：重置编辑状态（关闭弹窗时调用）
const resetEditState = () => {
  editingKey.value = ''; // 清空编辑标识
  // 清空编辑缓存（避免残留上一次编辑数据）
  Object.keys(editableData).forEach(key => {
    delete editableData[key];
  });
  // 清除可能存在的聚焦定时器（防止内存泄漏）
  const intervals = (window as any).focusIntervals || [];
  intervals.forEach((interval: number) => clearInterval(interval));
  (window as any).focusIntervals = [];
};
// 修改 startEdit 函数：记录定时器，方便后续清除
const startEdit = (record: any) => {
  // 1. 强制主窗口所有输入框失焦
  const mainInputs = document.querySelectorAll('input, textarea, select');
  mainInputs.forEach((input) => {
    (input as HTMLInputElement).blur();
  });

  // 2. 缓存编辑数据并设置编辑状态
  editableData[record.key] = cloneDeep(record);
  editingKey.value = `${record.key}-ParaValue`;

  // 3. 延迟聚焦+定时检查（修改：记录定时器到window，方便清除）
  const focusInterval = setInterval(() => {
    let target: HTMLInputElement | null = null;
    
    // 输入框
    if (getEditorType(record.ParaName) !== '下拉框' && 
        getEditorType(record.ParaName) !== '日期型' && 
        getEditorType(record.ParaName) !== '单选框') {
      target = document.querySelector(`.table-edit-input`) as HTMLInputElement;
    }
    // 下拉框
    else if (getEditorType(record.ParaName) === '下拉框') {
      target = document.querySelector(`.table-edit-select .ant-select-selection-search-input`) as HTMLInputElement;
    }
    // 日期选择器
    else if (getEditorType(record.ParaName) === '日期型') {
      target = document.querySelector(`.table-edit-date input`) as HTMLInputElement;
    }
    // 单选框
    else if (getEditorType(record.ParaName) === '单选框') {
      target = document.querySelector(`.table-edit-radio`) as HTMLInputElement;
    }

    if (target && editingKey.value === `${record.key}-ParaValue`) {
      target.focus();
    } else {
      clearInterval(focusInterval);
      // 从记录中移除已清除的定时器
      const intervals = (window as any).focusIntervals || [];
      (window as any).focusIntervals = intervals.filter((i: number) => i !== focusInterval);
    }
  }, 100);

  // 记录定时器，方便关闭时清除
  (window as any).focusIntervals = [(window as any).focusIntervals || [], focusInterval].flat();
};

// 2. 获取参数对应的编辑器类型（下拉框/日期型/单选框）
const getEditorType = (paraName: string) => {
  const editor = editors.value.find(e => e.PARANAME === paraName);
  return editor?.PARATYPE || '';
};

// 3. 获取下拉框选项
const getEditorItems = (paraName: string) => {
  const editor = editors.value.find(e => e.PARANAME === paraName);
  return editor?.Items || [];
};

// 4. 编辑值变化：同步到编辑缓存（无需实时更新原数据）
const handleEditChange = (rowKey: string, dataIndex: string) => {
  // 无需额外操作：v-model:value 已同步 editableData
};

// 5. 单选框变化（单独处理，因为 Radio 绑定逻辑不同）
const handleRadioChange = (rowKey: string, dataIndex: string, value: string) => {
  editableData[rowKey][dataIndex] = value;
};

// 6. 结束编辑：保存编辑值到原数据
const handleEditBlur = (rowKey: string, dataIndex: string, record: any) => {
  // 从编辑缓存获取最新值
  const newValue = editableData[rowKey][dataIndex];
  // 更新原表格数据
  const rowIndex = tableData.value.findIndex(item => item.key === rowKey);
  if (rowIndex !== -1) {
    tableData.value[rowIndex][dataIndex] = newValue;
  }
  // 清除编辑状态
  editingKey.value = '';
  delete editableData[rowKey];
};
// 新增：自动聚焦到第一行第2列（参数值列）
// 自动聚焦到第一行第2列（参数值列）
const autoFocusFirstCell = async () => {
  await nextTick(); 
  setTimeout(() => {
    const firstEditableRow = tableData.value.find(row => row.IsReadOnly !== 1);
    
    if (firstEditableRow) {
      startEdit(firstEditableRow); // 触发编辑，聚焦单元格
    } else {
      console.log('无可用编辑行，跳过自动聚焦');
    }
  }, 100); // 100ms延迟，适配二次打开时的DOM渲染速度
};
// ================ 原有工具函数和生命周期（不变，保留） ================
const getScriptMessage = (script: string) => {
  const lines = script.split('\n');
  if (lines.length === 0) return '';
  const firstLine = lines[0].trim();
  if (firstLine.includes('-')) {
    return firstLine.split('-')[1].trim();
  }
  return firstLine;
};

const analySQL = async () => {
  try {
    const script = fSQLScript.value;
    if (!script) {
      console.log('SQL脚本为空，跳过参数解析');
      return;
    }
    const paramRegex = /\{([^}]+)\}/g;
    const params = new Set<string>();
    let match;
    while ((match = paramRegex.exec(script)) !== null) {
      params.add(match[1]);
    }
    if (params.size === 0) {
      chkNextEnabled.value = false;
      console.log('未从SQL脚本中解析到参数');
      return;
    }
    for (const [idx, paramName] of Array.from(params).entries()) {
      const execParams = {
        apicode: 'S_Insert_SQLPara',
        ParaType: 'varchar',
        isHide: 0,
        isReadOnly: 0,
        ItemCode: props.itemCode,
        ParaName: paramName,
        idx
      };
      const success = await dm.value.exec('/api/comm/exec/', execParams);
      if (success) {
        console.log(`参数【${paramName}】插入成功`);
      } else {
        console.warning(`参数【${paramName}】插入失败`);
      }
    }
    // chkNextEnabled.value = false;
    console.log(`共解析到 ${params.size} 个参数，已完成插入`);
  } catch (error) {
    console.error('解析SQL参数并插入数据库失败:', error);
    Message.error('参数解析失败，请重试！');
    chkNextEnabled.value = false;
  }
};

const initEditors = async () => {
  try {
    const editorList = [];
    const params = {
      apicode: 'SQLScript_2112010004',
      ITEMCODE: props.itemCode
    };
    const dtRes = await dm.value.data('/api/comm/data/', params);
    const dt = dtRes?.data?.list || [];
    for (const dr of dt) {
      const es = {
        ITEMCODE: dr.ITEMCODE || '',
        PARANAME: dr.PARANAME || '',
        PARATYPE: dr.PARATYPE || '',
        PARADBNAME: dr.PARADBNAME || '',
        PARADEFAULT: dr.PARADEFAULT || '',
        REPORTPARALIST: dr.REPORTPARALIST || '',
        Items: []
      };
      const lines = es.REPORTPARALIST.split('\n');
      for (const line of lines) {
        const sql = getSqlFromLine(line.trim());
        if (sql) {
          const optionParams = { apicode: sql };
          const optionRes = await dm.value.data('/api/comm/data/', optionParams);
          const optionDt = optionRes?.data?.list || [];
          es.Items.push(...optionDt.map((row) => row[0] || ''));
        } else if (line.trim()) {
          es.Items.push(line.trim());
        }
      }
      editorList.push(es);
    }
    editors.value = editorList;
    // console.log('编辑器配置初始化完成，数量：', editorList.length);
  } catch (error) {
    console.error('初始化编辑器配置失败:', error);
    editors.value = [];
  }
};

const getSqlFromLine = (line: string) => {
  const startIdx = line.indexOf('[SQL:');
  if (startIdx === -1) return '';
  const endIdx = line.lastIndexOf(']');
  return endIdx > -1 ? line.substring(startIdx + 5, endIdx) : '';
};

const fillFrmObj = async () => {
  try {
    tableData.value = [];
    const params = {
      apicode: 'SQLScript_210810870',
      ItemCode: props.itemCode
    };
    const res = await dm.value.data('/api/comm/data/', params);
    const dt = res?.data?.list || [];
    tableData.value = dt.map((row: any, idx: number) => ({
      key: idx,
      Guid: row.Guid || '',
      ParaName: row.ParaName || '',
      Remarks: row.Remarks || '',
      ParaValue: row.ParaValue || '',
      iType: row.iType || '',
      IsNotNull: row.NotNull || 0,
      IsReadOnly: row.IsReadOnly || 0
    }));
    await nextTick();
    console.log('表格数据初始化完成，行数：', tableData.value.length);
  } catch (error) {
    console.error('填充表格数据失败:', error);
    tableData.value = [];
  }
};

const checkParams = () => {
  for (const record of tableData.value) {
    if (record.IsNotNull === 1 && !record.ParaValue) {
      Message.warning(`参数【${record.ParaName}】为必填项，不能为空！`);
      return false;
    }
  }
  return true;
};

const handleOk = async () => {
  if (!checkParams()) return; // 校验必填参数，不通过则返回
  try {
    // 1. 处理参数格式，准备执行SQL
    const sqlParameters: any[] = [];
    for (const record of tableData.value) {
      const { ParaName, ParaValue, iType } = record;
      let sqlDbType = 'VarChar';
      // 根据参数类型映射SQL数据库类型
      switch (iType) {
        case 'integer': sqlDbType = 'Int'; break;
        case 'money': sqlDbType = 'Money'; break;
        case 'float': sqlDbType = 'Float'; break;
        case 'datetime': sqlDbType = 'DateTime'; break;
        case 'date': sqlDbType = 'Date'; break;
        case 'bit': sqlDbType = 'Bit'; break;
      }
      // 处理参数值格式
      let paramValue = ParaValue || null;
      switch (iType) {
        case 'integer': paramValue = parseInt(ParaValue) || 0; break;
        case 'money': 
        case 'float': paramValue = parseFloat(ParaValue) || 0; break;
        case 'datetime': 
        case 'date': paramValue = ParaValue ? dayjs(ParaValue).toDate() : null; break;
        case 'bit': paramValue = ParaValue === '是'; break;
      }
      sqlParameters.push({ 
        ParameterName: ParaName, 
        SqlDbType: sqlDbType, 
        Value: paramValue 
      });
    }

    // 2. 替换SQL中的参数并执行
    let sql = dm.value.replaceSqlPara(fSQLScript.value, sqlParameters);
    if (sql.includes('{')) {
      Message.error('存在未初始化的{参数}，执行终止！');
      return;
    }
    const execParams = {
      apicode: '',
      sql: sql,
      dbName: fDBName.value,
      isAsync: false
    };
    const res = await dm.value.data('/api/comm/data/', execParams);
    const dt = res?.data?.list || [];

    // 3. 处理执行结果
    if (dt.length > 0) {
      if ('RET' in dt[0]) {
        const ret = dt[0].RET;
        if (ret >= 1) {
          Message.success(dt[0].MSG || '执行成功！');
        } else {
          Message.error(`错误号：${ret}\n${dt[0].MSG || '执行失败！'}`);
          return; // 执行失败则不关闭弹窗
        }
      } else {
        Message.success(dt[0].MSG || '执行成功！');
      }
    } else {
      Message.success('执行成功！');
    }

    // 4. 根据「继续录入」选项处理后续逻辑
    if (chkNext.value) {
      // 继续录入：清空参数值，保持弹窗打开，并重新聚焦第一行
      tableData.value.forEach((row) => {
        if (row.IsReadOnly !== 1) row.ParaValue = ''; // 只读行不清除
      });
      await nextTick(); // 等待数据更新后再聚焦
      autoFocusFirstCell(); // 重新聚焦到第一行第2列
    } else {
      // 不继续录入：关闭弹窗前重置编辑状态
      resetEditState();
      emit('close', true); // 通知父组件关闭弹窗
    }
  } catch (error: any) {
    Message.error(`执行失败：${error.message}`);
  }
};

const handleExit = () => {
  resetEditState(); // 关闭前重置编辑状态
  emit('close', false);
};

const handleClear = async () => {
  if (window.confirm('确定要清除全部参数和值吗?')) {
    try {
      const params = {
        apicode: 'S_ClearSQLPara',
        ItemCode: props.itemCode
      };
      const success = await dm.value.exec('/api/comm/exec/', params);
      if (success) {
        tableData.value = [];
        Message.success('参数已清除！');
      } else {
        Message.warning('清除失败：未返回成功状态');
      }
    } catch (error) {
      console.error('清除参数执行失败:', error);
      Message.error('清除参数时发生错误，请重试！');
    }
  }
};

const getScriptAndDbName = async () => {
  try {
    const params = {
      apicode: 'S_GetSQLScript_ByItemCode',
      '脚本代码': props.itemCode
    };
    const res = await dm.value.data('/api/comm/data/', params);
    const scriptDt = res?.data?.list || [];
    if (scriptDt.length > 0) {
      const dr = scriptDt[0];
      fSQLScript.value = dr.SQLScript || '';
      fDBName.value = dr.DBName || '';
      displayMessage.value = getScriptMessage(fSQLScript.value);
      // console.log('SQL脚本获取成功，数据库名：', fDBName.value);
    } else {
      fSQLScript.value = '';
      fDBName.value = '';
      displayMessage.value = '';
      console.log('未查询到对应SQL脚本');
    }
  } catch (error) {
    console.error('获取SQL脚本和数据库名失败:', error);
    fSQLScript.value = '';
    fDBName.value = '';
    displayMessage.value = '';
  }
};

const initData = async () => {
  // 重置状态（避免残留上次数据）
  resetEditState();
  tableData.value = [];
  editors.value = [];
  fSQLScript.value = '';
  fDBName.value = '';
  displayMessage.value = '';
  bInit.value = false;

  // 重新查询所有数据
  await fillFrmObj();         // 重新填充表格参数数据
  await getScriptAndDbName(); // 重新获取SQL脚本和数据库名
  await analySQL();           // 重新解析SQL参数
  await initEditors();        // 重新初始化编辑器配置

  // 自动聚焦到第一行参数值列
  await nextTick();
  autoFocusFirstCell();
  
  bInit.value = true;
  console.log('子组件初始化数据，itemCode:', props.itemCode);
};

// 监听 visible 变化：当组件从隐藏变为显示时，自动初始化
watch(
  () => props.visible,
  (newVisible, oldVisible) => {
    // 只有当“从隐藏变为显示”时才执行（避免重复触发）
    if (newVisible && !oldVisible) { 
      nextTick(async () => {
        await initData();
      });
    }
  }
);

const emit = defineEmits<{
  (e: 'close', success: boolean): void;
}>();

onMounted(async () => {
  await initData();  
});

defineExpose({
  handleOk,
  handleExit,
  initData // 暴露初始化方法
});
</script>

<style scoped>
/* 原有样式不变，添加以下样式优化编辑状态 */
.sql-editor {
  padding: 16px;
  font-size: 14px;
  position: relative;
}

.header {
  margin-bottom: 16px;
  font-size: 16px;
}

.message {
  margin-bottom: 16px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
}

.button-group {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
}

:deep(.ant-table-cell) {
  padding: 4px !important;
}

:deep(.ant-input),
:deep(.ant-select-selector),
:deep(.ant-date-picker-input) {
  border-radius: 4px !important;
}

:deep(.ant-table-container) {
  border-top: 1px solid #e8e8e8 !important;
}

/* 可选：修复滚动时表格底部边框 */

</style>

